import axios from 'axios'
import { PLATFORM_HTTP_RETCODE } from '../constant'
import { getErrMsg, ResponseError, TransformError } from './error'
import observer from '../observer'
import i18n from '@/i18n'

function checkCode(code, msg) {
  if (code === PLATFORM_HTTP_RETCODE.Ok) {
    return
  }
  const respErr = new ResponseError(code, msg || i18n.tc('home.UnknownMistake'))
  switch (code) {
    case PLATFORM_HTTP_RETCODE.NOGRANT:
      // 未授权
      break
    case PLATFORM_HTTP_RETCODE.NOLOGIN:
      observer.$emit('logout', respErr)
      // 未登录
      break
    default:
  }
  throw respErr
}

const platformHttp = axios.create({
  withCredentials: true
})

platformHttp.interceptors.response.use(
  resp => {
    const conf = resp.config
    const resData = resp.data

    const retCode = resData?.retCode || 0
    const comment = resData?.comment || ''

    checkCode(retCode, comment)

    if (conf.isTransformRequestResult === false) {
      return resData
    }

    return resData.data
  },
  error => {
    // 最后的错误收集处理
    if (axios.isAxiosError(error)) {
      let { status, statusText, data } = error.response
      if (data) {
        const { retCode, comment } = data
        if (retCode) {
          status = retCode
        }

        if (comment) {
          statusText = comment
        }
      }
      return Promise.reject(new TransformError(status, statusText || getErrMsg(status)))
    }
    return Promise.reject(error)
  }
)

export default platformHttp
